// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input,TextField
} from "@mui/material";

// App Imports
import {changePlatform} from "./platformSlice";
import {addPlatform, editPlatform} from "./PlatformClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import Stack from "@mui/material/Stack";


// Main Function
export default function PlatformDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorPlatformId = useSelector((state) => state.platformSlc.value.id);
    const selectorPlatformDrawerState = useSelector((state) => state.platformSlc.value.platformDrawerState);
    const selectorPlatformDrawerMode = useSelector((state) => state.platformSlc.value.platformDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Platform data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorPlatformDrawerMode==="Add"){
            addPlatform(data)
                .then(() => {
                    console.log("Platform added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changePlatform({
                    id: null, dataPointId: null, productId: null,
                    platformStatus: null,
                    dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
                    productCode:null, productName: null, category: null, productStatus: null,status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    platformGridRefresh: true, platformDrawerState: false, platformDrawerMode: null}))
            })}
        if(selectorPlatformDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addPlatform(data)
                .then(() => {
                    console.log("Platform cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changePlatform({id: null, externalId: null, amount: null, displayAmount: null, availBegin: null,
                    availEnd: null, executionDate: null, platforme: null, market: null, territory: null,
                    propertyId: null, exhibitionDays: null, runs: null,status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    propertyName: null, initialMarket: null, genre: null, productionType: null,
                    platformGridRefresh: true, platformDrawerState: false, platformDrawerMode: null}))

            })}
        if(selectorPlatformDrawerMode==="Edit"){
            console.log("This is the Platform Id I am going to edit")
            console.log(selectorPlatformId)
            editPlatform(selectorPlatformId, data)
                .then(() => {
                    console.log("Platform edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changePlatform({
                    platformGridRefresh: true, platformDrawerState: false, platformDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closePlatformDrawer() {
        dispatchData(changePlatform({platformDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);


            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);

// *********************** END DROPDOWNS **************************

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    // ****************** BEGIN FORM ****************************

    function platformForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closePlatformDrawer()}>Platform Form</h2>
                    <h4>{selectorPlatformDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <Input
                        style={{ visibility: "hidden" }}
                        {...register('id', { required: true })}
                        id="id" name="id"  label="id" aria-describedby="id_entry"
                        defaultValue=        {Number(useSelector((state) => state.platformSlc.value.id))}
                    />
                    <Stack direction="row" spacing={2}>
                    <TextField
                        {...register('externalId', { required: true })}
                        id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                        defaultValue=        {useSelector((state) => state.platformSlc.value.externalId)}
                        sx={{ width: 200 }} />
                    <TextField
                        {...register('mcode', { required: true })}
                        id="mcode"   name="mcode"  label="Code" aria-describedby="mcode_entry"
                        defaultValue=        {useSelector((state) => state.platformSlc.value.mcode)}
                        sx={{ width: 200 }} />
                    <TextField
                        {...register('name', { required: true })}
                        id="name"   name="name"  label="Name" aria-describedby="name_entry"
                        defaultValue=        {useSelector((state) => state.platformSlc.value.name)}
                        sx={{ width: 200 }} />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                    <TextField
                        {...register('service', { required: false })}
                        id="service"   name="service"  label="Service" aria-describedby="service_entry"
                        defaultValue=        {useSelector((state) => state.platformSlc.value.service)}
                        sx={{ width: 200 }} />
                    <TextField
                        {...register('usageMarket', { required: true })}
                        id="usageMarket"   name="usageMarket"  label="Usage Market" aria-describedby="usageMarket_entry"
                        defaultValue=        {useSelector((state) => state.platformSlc.value.usageMarket)}
                        sx={{ width: 200 }} />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                    <TextField
                        {...register('territory', { required: false })}
                        id="territory"   name="territory"  label="Territory" aria-describedby="territory_entry"
                        defaultValue=        {useSelector((state) => state.platformSlc.value.territory)}
                        sx={{ width: 200 }} />
                    <TextField
                        {...register('owner', { required: false })}
                        id="owner"   name="owner"  label="Owner" aria-describedby="owner_entry"
                        defaultValue=        {useSelector((state) => state.platformSlc.value.owner)}
                        sx={{ width: 200 }} />
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status"
                            aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.platformSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.platformSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.platformSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.platformSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.platformSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closePlatformDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>

            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorPlatformDrawerState}
                onClose={closePlatformDrawer}
            >
                {platformForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
